import {call, put} from 'redux-saga/effects';

import axios from 'axios';
import * as lexActionType from '../actionsType/lexGenCopyLink.actionType';
import {getBaseUrl} from '../../../core/utility/filter.utility';

function generateLink(reqObj) {
    return axios({
        method: 'post',
        // url: `${getBaseUrl()}/rest/coursecomposerservice/generateCourseLink`,
        // data: {
        //     lObjId: 100516,
        //     lang: 'en',
        //     vault: '2'
        // }
        url: `${getBaseUrl()}/rest/lp/generateContentLink`,
        data: {
            lpId: reqObj.lcId,
            lang: reqObj.lang,
            lexType: reqObj.lexType
        }
    });
}


export function* generateCopyLinkSaga(request) {
    try {
        const response = yield call(generateLink, request.payload);
        const content = response.data.url;
        yield put({
            type: lexActionType.LEX_GENERATELINK_SUCCESS,
            payload: content
        });
    } catch (error) {
        yield put({
            type: lexActionType.LEX_GENERATELINK_ERROR,
            payload: 'There has been some issue with 3DS Learning Space. Please try after sometime.'
        });
    }
}
